import MuiButton from './MuiButton';
import MuiCardActions from './MuiCardActions';
import MuiCardContent from './MuiCardContent';
import MuiCardHeader from './MuiCardHeader';
import MuiChip from './MuiChip';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiLinearProgress from './MuiLinearProgress';
import MuiListItemIcon from './MuiListItemIcon';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiTableHead from './MuiTableHead';
import MuiTableCell from './MuiTableCell';
import MuiTableRow from './MuiTableRow';
import MuiToggleButton from './MuiToggleButton';
import MuiTypography from './MuiTypography';
import MuiCssBaseline from './MuiCssBaseline';

export default (palette) => ({
  MuiButton,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiChip,
  MuiIconButton: MuiIconButton(palette),
  MuiInputBase: MuiInputBase(palette),
  MuiLinearProgress,
  MuiListItemIcon: MuiListItemIcon(palette),
  MuiOutlinedInput,
  MuiPaper,
  MuiTableHead: MuiTableHead(palette),
  MuiTableCell: MuiTableCell(palette),
  MuiTableRow: MuiTableRow(palette),
  MuiToggleButton: MuiToggleButton(palette),
  MuiTypography,
  MuiCssBaseline
});
